import React, { Component } from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import { HIDE_MODAL, AAF_MODAL_ACTUALIZA_TUS_DATOS_2FA } from '../../actions/modal';
import { cls, Row, Column, Button } from '../../packages/components';
import './styles/AAFModalActualizaTusDatos2FA.scss';
import Translator from '../../requests/apa/Translator';
import store from '../../store';
import { ACTUALIZATUSDATOS, SIGUIENTE, MODALACTUALIZATUSDATOS } from '../../AAFPlayer/constants';
import {GA4} from '../../utils/trackers/GA4';
import Utils from '../../utils/Utils';

const MAIN_CLASSNAME = 'modal-update-contact';
const MAIN_TEXTNAME_CLASSNAME = 'aaf_text-update-contact';

const getContentText = (key = null) => {
	const translation = Translator.get(key)
	if(translation === "" || translation === undefined){
		return key
	} else if(translation === null){
		return '\u00A0'
	}else{
		return translation
	} 
}

const Title = () => (
	<Column lg={12}>
		<p className={cls(`${MAIN_TEXTNAME_CLASSNAME} title`)}>
			{getContentText('Alerta_2FATelmex_ActualizaDatos_TextoTitulo')}
		</p>
	</Column>
);

const OneText = () => {
	return (
		<div>
			<p className={cls(`${MAIN_TEXTNAME_CLASSNAME} oneText`)}>
				{getContentText('Alerta_2FATelmex_ActualizaDatos_TextoMensaje1_Parte1')}{' '}
				<span className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{getContentText('Alerta_2FATelmex_ActualizaDatos_TextoMensaje1_Parte2')}</span>{' '}
				{getContentText('Alerta_2FATelmex_ActualizaDatos_TextoMensaje1_Parte3')}{' '}
			</p>
		</div>
	)
}

const InfoText = () => (
	<div className={cls(`${MAIN_TEXTNAME_CLASSNAME} infoText`)}>
		<p>
		{getContentText('Alerta_2FATelmex_ActualizaDatos_TextoMensaje2_Parte1')}{' '}
		<span className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{getContentText('Alerta_2FATelmex_ActualizaDatos_TextoMensaje2_Parte2')}</span>{' '}
		{getContentText('Alerta_2FATelmex_ActualizaDatos_TextoMensaje2_Parte3')}
		</p>
	</div>
);

const HelpTitle = () => (
	<div>
		<p className={cls(`${MAIN_TEXTNAME_CLASSNAME} titleHelp`)}>
			{getContentText('Alerta_2FATelmex_TextoTituloAyuda')}
		</p>
	</div>
);

const HelpText1 = () => (
	<div>
		<p className={cls(`${MAIN_TEXTNAME_CLASSNAME} textHelp`)}>
			{getContentText('Alerta_2FATelmex_ActualizaDatos_TextoAyuda1')} 
		</p>
	</div>
)

const hideModalAndGoBack = (e, history, getParamsMetrics2FA) => {
	const gA4 = new GA4();
	gA4.sendMetrics2FA(getParamsMetrics2FA, SIGUIENTE);

    e.preventDefault();
    e.stopPropagation();
	store.dispatch({
		type: HIDE_MODAL
	})
};

const BodyActualizaTusDatos = ({ history, getParamsMetrics2FA }) => {
	return (
		<div className={MAIN_CLASSNAME}>
			<Row className={cls(`${MAIN_CLASSNAME} divTitle`)}>
				<Title />
			</Row>
			<Row className={cls(`${MAIN_CLASSNAME} divOneText`)}>
				<OneText />
			</Row>
			<Row className={cls(`${MAIN_CLASSNAME} divInfo`)}>
				<InfoText/>
			</Row>
			<Row className={cls(`${MAIN_CLASSNAME} divButton`)}>
				<Button
					activate
					type="button"
					variant="primary"
					className={cls(`${MAIN_TEXTNAME_CLASSNAME} primaryButton focusable`)}
					onClick={(e) => hideModalAndGoBack(e, history, getParamsMetrics2FA)}
					>
					{getContentText('Alerta_2FATelmex_TextoBotonPrimario_Siguiente')}
				</Button>
			</Row>
			<Row className={cls(`${MAIN_CLASSNAME} divTitleHelp`)}>
				<HelpTitle />
			</Row>
			<Row className={cls(`${MAIN_CLASSNAME} divTextHelp1`)}>
				<HelpText1 />
			</Row>
		</div>
	);
};

class AAFModalActualizaTusDatos2FA extends Component {

	constructor(props) {
		super(props);
		this.getParamsMetrics2FA = Utils.getParamsMetricsModals2FA(props.dataMetrics2FA, ACTUALIZATUSDATOS, props.history.location.pathname, MODALACTUALIZATUSDATOS);
	}


	handleBack = () => {
		// Al hacer BACK con el RCU.
		store.dispatch({
			type: HIDE_MODAL
		})
	}

	render(){
		const { history } = this.props;
		return (
			<ModalWrapper className="aaf_app_modal-update-contact" callbackWhenBack={this.handleBack}>
				<BodyActualizaTusDatos history={history} getParamsMetrics2FA = {this.getParamsMetrics2FA}/>
			</ModalWrapper>
		);
	}
}

export default withOnClose(AAFModalActualizaTusDatos2FA);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalActualizaTusDatos2FA.jsx